// src/utils/services/alerts.ts - version 0.1
import {
  ElMessage,
  ElMessageBox,
  ElNotification,
  ElLoading,
} from "element-plus";
import type { MessageBoxData } from "element-plus";

export const alerts = {
  // Toast messages (auto-dismiss)
  toast: {
    success: (message: string) => ElMessage.success(message),
    info: (message: string) => ElMessage.info(message),
    warning: (message: string) => ElMessage.warning(message),
    error: (message: string) => ElMessage.error(message),
  },

  // Modal dialogs
  modal: {
    alert: (
      message: string,
      title = "Alert",
      type: "info" | "success" | "warning" | "error" = "info"
    ) => ElMessageBox.alert(message, title, { type }),

    success: (message: string, title = "Success") =>
      ElMessageBox.alert(message, title, { type: "success" }),

    warning: (message: string, title = "Warning") =>
      ElMessageBox.alert(message, title, { type: "warning" }),

    error: (message: string, title = "Error") =>
      ElMessageBox.alert(message, title, { type: "error" }),

    confirm: (message: string, title = "Confirm"): Promise<MessageBoxData> =>
      ElMessageBox.confirm(message, title, { type: "warning" }),

    prompt: (
      message: string,
      title = "Input",
      inputValue = ""
    ): Promise<MessageBoxData> =>
      ElMessageBox.prompt(message, title, { inputValue }),
  },

  // Persistent notifications
  notify: (
    title: string,
    message: string,
    type: "success" | "info" | "warning" | "error" = "info"
  ) => ElNotification({ title, message, type }),

  // Loading overlay
  loading: (text = "Loading...") =>
    ElLoading.service({ text, lock: true, background: "rgba(0, 0, 0, 0.7)" }),
};

export default alerts;
